/* global IntersectionObserver */
export const observeBlocks = () => {
    const ioCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // console.log('attempting to init', entry.target)
                // console.log(entry.target.expandygg)
                try {
                    entry.target.expandygg?.init()
                } catch(e) {
                    console.error(e, `at block`, entry.target)
                } finally {
                    observer.unobserve(entry.target)
                }
            }
        })
    }

    const blocksIntersectionObserver = new IntersectionObserver(ioCallback, {
        root: null,
        rootMargin: '0px',
        threshold: 0,
    })

    ;[ ...document.querySelectorAll('[data-ygg-block]') ].forEach($block => blocksIntersectionObserver.observe($block))
}